import React from 'react'
import Image from './Image'

export default function HomeImage() {
  return (
    <div className="home__right">
      <Image />
    </div>
  )
}
